
class account {
    create(params) {
        return new Promise(async (resolve, reject) => {
            try {
                let res = await axios.post('accounting/account', params);
                if (res) {
                    resolve(true);
                }
            }
            catch (error) {
                reject(error);
            }
        });
    }

    edit(params) {
        return new Promise(async (resolve, reject) => {
            try {
                let res = await axios.put('accounting/account/' + params.id, params);
                if (res) {
                    resolve(true);
                }
            }
            catch (error) {
                reject(error);
            }
        });
    }

    get(active = 0) {
        return new Promise(async (resolve, reject) => {
            try {
                let res = await axios.get('accounting/account', { params: { active: active } });
                resolve(res.data);
            }
            catch (error) {
                reject(error);
            }
        });
    }

    destroy(id) {
        return new Promise(async (resolve, reject) => {
            try {
                let res = await axios.delete('accounting/account/' + id);
                resolve(res.data);
            }
            catch (error) {
                reject(error);
            }
        });
    }

    getTrans(id, params) {
        return new Promise(async (resolve, reject) => {
            try {
                let res = await axios.get('accounting/account/transactions/' + id, { params: params });
                resolve(res.data);
            }
            catch (error) {
                reject(error);
            }
        });
    }
}

let app = new account;
export default app;
